<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEmailCheckOutline } from "@mdi/js";
export default {
  name: "MdiEmailCheckOutline",
  data() {
    return {
      svgPath: mdiEmailCheckOutline,
    };
  },
};
</script>
